import React, { useContext, useState, useEffect } from 'react'; 
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import styles from './styles/ChoicesList.module.css';
import CanvasContext from '../../../context/CanvasContext';


const ChoicesList = () => {
    const {
        selectedSituation,    
        selectedNodeId,       
        updateSituationAndNode, 
        getChoice,
        setActiveEditTab,
        loading               
    } = useContext(CanvasContext);

    
    
    const [displayChoices, setDisplayChoices] = useState([]);

    
    useEffect(() => {
        setDisplayChoices(selectedSituation?.choices || []);
    }, [selectedSituation]); 

    const handleDragEnd = async (result) => {
        if (!result.destination) return;

        
        if (!selectedNodeId || loading) {
            console.log("Drag prevented: No situation selected or already loading.");
            return;
        }

        
        const reorderedChoices = Array.from(displayChoices);
        const [removed] = reorderedChoices.splice(result.source.index, 1);
        reorderedChoices.splice(result.destination.index, 0, removed);

        
        setDisplayChoices(reorderedChoices);

        
        const reorderedChoiceIds = reorderedChoices.map(choice => choice._id);

        try {
            await updateSituationAndNode(selectedNodeId, { choices: reorderedChoiceIds });
            console.log('Choice order persisted.');
        } catch (error) {
            console.error("Error updating choice order:", error);
            setDisplayChoices(selectedSituation?.choices || []); 
            
        }
    };

    const handleChoiceClick = async (choiceId) => {
        if (!choiceId) return;
        
        if (loading) {
            console.log("Action prevented: Loading.");
            return;
        }
        try {
            await getChoice(choiceId); 
            setActiveEditTab('1'); 
        } catch (error) {
             console.error("Error fetching choice on click:", error);
        }
    };


    return (
        
        <DragDropContext onDragEnd={handleDragEnd} isDragDisabled={loading}>
            <Droppable droppableId="droppable-choices">
                {(provided, snapshot) => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        
                        className={`${styles.choicesContainer} ${loading ? styles.disabled : ''}`}
                    >
                        {displayChoices.length > 0 ? (
                            displayChoices.map((choice, index) => (
                                <Draggable
                                    key={choice?._id ?? `choice-${index}`} 
                                    draggableId={choice?._id ?? `choice-${index}`} 
                                    index={index}
                                    isDragDisabled={loading} 
                               >
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className={`${styles.choiceItem} ${snapshot.isDragging ? styles.dragging : ''}`}
                                            onClick={() => !snapshot.isDragging && !loading && handleChoiceClick(choice?._id)} 
                                            style={{
                                                 
                                                 ...provided.draggableProps.style,
                                            }}
                                            
                                            aria-label={`Choice: ${choice?.title || 'Untitled'}. Linked to: ${choice?.nextSituation?.title || 'Unlinked'}. Position ${index + 1} of ${displayChoices.length}.`}
                                        >
                                            <div className={styles.choiceTitle}>
                                                {choice?.title || 'Untitled'}
                                            </div>
                                            <div className={styles.nextSituationTitle}>
                                                <span className={styles.linkLabel}>Links to:</span> {choice?.nextSituation?.title || 'Unlinked'}
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))
                        ) : (
                            
                            !loading && (
                                 <p className={styles.noChoices}>No choices defined for this situation.</p>
                            )
                        )}
                        {provided.placeholder}
    
                        {loading && (
                            <div className={styles.loadingOverlay}>
                                <div className={styles.loadingSpinner}></div>
                                <span>Saving...</span>
                            </div>
                        )}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );
};

export default ChoicesList;